import {select} from 'redux-saga/effects';
import {Scope} from 'Shared/constants/Scope';
import {extractApplicationIdsFromScope} from 'Shared/utilities/applicationId';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

export function* extractApplicationIdsFromScopeSaga(designatedScope: Scope) {
  const scopes: Scope[] = yield select(selectUserScopes);

  // If all access scope exist, then return empty array.
  if (scopes.find(scope => scope.toString() === `${designatedScope}|*`)) {
    return [];
  }

  return extractApplicationIdsFromScope(scopes, designatedScope);
}
